import styled, { css } from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

import { documentStatus } from '../../constants/Documents';

export interface IFileItemStatusProps {
  readonly $status: string;
}

export const FileItemStatusContainer = styled.div<IFileItemStatusProps>`
  ${({ $status }) => {
    switch ($status) {
      case documentStatus.waitingForApproval:
        return css`
          color: ${colors.statusTextMedium};
        `;
      case documentStatus.approved:
        return css`
          color: ${colors.statusTextSuccess};
        `;
      default:
        return css`
          color: ${colors.statusTextError};
        `;
    }
  }}
`;
